import { render, staticRenderFns } from "./DocumentHistoryComponent.vue?vue&type=template&id=5e01ec26&scoped=true&"
import script from "./DocumentHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentHistoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentHistoryComponent.vue?vue&type=style&index=0&id=5e01ec26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e01ec26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer})
